module.exports = __webpack_public_path__ + "img/mbh5.0db59e63.jpg";